import React from 'react';

/**
 * Page representing an agent's Leads.
 */
export const Leads = () => {
  return (
    <div>
      <h2>Leads</h2>
    </div>
  );
};
